import { render, staticRenderFns } from "./IndustryDefinitionEditor.vue?vue&type=template&id=4db6a693&scoped=true"
import script from "./IndustryDefinitionEditor.vue?vue&type=script&lang=js"
export * from "./IndustryDefinitionEditor.vue?vue&type=script&lang=js"
import style0 from "./IndustryDefinitionEditor.vue?vue&type=style&index=0&id=4db6a693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6a693",
  null
  
)

export default component.exports